import { Component, ViewEncapsulation, Input } from '@angular/core';
import { ProductCatalog } from '../../../models/product-catalog.model';

export const OD_PROGRAM_TYPE = 'ECOMMERCE_GROUP';

@Component({
    selector: 'programs-grid',
    templateUrl: './programs-grid.component.html',
    styleUrls: ['./programs-grid.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProgramsGridComponent {
    @Input()
    public programs: ProductCatalog[];

    constructor() {

    }


    isODProgram(program: ProductCatalog): boolean {
        return program.type === OD_PROGRAM_TYPE;
    }
}
